import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import * as Unicons from "@iconscout/react-unicons";
import axios from "axios";
import loginImg from "../assets/login.png";
import "./style.css";

import { useAuth } from "./../utils/useAuth";
import Intro from "../components/Intro";
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/slicers/authInfo";
import ImgOptimized from "../components/ImgOptimized";
import classNames from "classnames";
import { getUpdatedImageUrlWithSize } from "../utils/helpers";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const dispatch = useDispatch();
  const LOGIN_ID = localStorage.getItem("loginId");
  const IS_VALID_LOGIN_ID =
    LOGIN_ID && LOGIN_ID !== "undefined" && LOGIN_ID !== "null";
  const [loginId, setLoginId] = useState({
    loginId: LOGIN_ID,
    isValid: IS_VALID_LOGIN_ID,
  });
  const [otpBtnLoading, setOtpBtnLoading] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);

  // Add CSS for continuous scrolling animations
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes scrollDown {
        0% { transform: translateY(-5%); }
        100% { transform: translateY(-55%); }
      }
      
      @keyframes scrollUp {
        0% { transform: translateY(-55%); }
        100% { transform: translateY(-5%); }
      }
      
      .scroll-down-container {
        animation: scrollDown 30s linear infinite alternate;
      }
      
      .scroll-up-container {
        animation: scrollUp 30s linear infinite alternate;
      }
      
      .image-container {
        transition: transform 0.3s ease;
      }
      
      .image-container:hover {
        transform: scale(1.05);
        z-index: 10;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  if (isAuthenticated) {
    navigate("/home");
  }
  const [passShow, setPassShow] = useState(false);
  const [inpval, setInpval] = useState({
    email: "",
    password: "",
    otp: "",
  });

  // Left column images
  const LEFTCARAOUSEL = useMemo(() => {
    let leftImages = [
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/99052.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/280719.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/316881.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/88795.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/339900.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/89428.jpg",
    ];
    leftImages = leftImages.map((i) =>
      getUpdatedImageUrlWithSize(i, [2, 2, 3]),
    );

    // Right column images (different from left)
    let rightImages = [
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/233823.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/99068.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/383950.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/425151.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/74914.jpg",
      "https://design-api.airbrickinfra.com/api/minio/static/brick-img/409494.jpg",
    ];
    rightImages = rightImages.map((i) =>
      getUpdatedImageUrlWithSize(i, [2, 2, 3]),
    );

    return (
      <Box
        className="flex md:min-h-[500px] md:basis-[50%] items-center"
        h={"100%"}
        style={{
          overflow: "hidden",
          padding: "0",
        }}
      >
        {/* <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'stretch',
              justifyContent: 'center',
            }}
          > */}
        <div className="md:hidden overflow-hidden relative w-screen h-full">
          <div className="login-right-carousel-container flex w-fit">
            {/* Original images */}
            {leftImages.map((img, idx) => (
              <div
                key={`left-${idx}`}
                className="image-container flex-shrink-0 w-48 mr-4"
              >
                <ImgOptimized
                  src={img}
                  alt={`masonry-left-${idx}`}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            ))}
            {/* Duplicate images for seamless loop */}
            {leftImages.map((img, idx) => (
              <div
                key={`left-duplicate-${idx}`}
                className="image-container flex-shrink-0 w-48 mr-4"
              >
                <ImgOptimized
                  src={img}
                  alt={`masonry-left-duplicate-${idx}`}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="md:flex hidden md:flex-row flex-col w-full h-full px-4 gap-4 overflow-hidden">
          {/* Left column - continuously scrolling down */}
          <div
            className="flex-1 hidden md:block overflow-hidden relative"
            style={{ height: "100%" }}
          >
            <div
              className={`scroll-up-container flex md:block w-full`}
              style={{ height: "200%" }}
            >
              {/* First set of images */}
              {leftImages.map((img, idx) => (
                <div
                  key={`left-${idx}`}
                  className="image-container mb-4"
                  style={{
                    height: `${Math.floor(Math.random() * 100) + 160}px`,
                    marginBottom: "16px",
                  }}
                >
                  <ImgOptimized
                    src={img}
                    alt={`masonry-left-${idx}`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      borderRadius: "16px",
                      objectFit: "cover",
                      background: "#eee",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              ))}
              {/* Duplicate images for seamless loop */}
              {leftImages.map((img, idx) => (
                <div
                  key={`left-dup-${idx}`}
                  className="image-container mb-4"
                  style={{
                    height: `${Math.floor(Math.random() * 100) + 160}px`,
                    marginBottom: "16px",
                  }}
                >
                  <ImgOptimized
                    src={img}
                    alt={`masonry-left-dup-${idx}`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      borderRadius: "16px",
                      objectFit: "cover",
                      background: "#eee",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right column - continuously scrolling up */}
          <div
            className="flex-1 hidden md:block overflow-hidden relative"
            style={{ height: "100%" }}
          >
            <div
              className="scroll-down-container flex gap-5 md:block  w-full"
              style={{ height: "200%" }}
            >
              {rightImages.map((img, idx) => (
                <div
                  key={`right-${idx}`}
                  className="image-container mb-4"
                  style={{
                    height: `${Math.floor(Math.random() * 100) + 160}px`,
                    marginBottom: "16px",
                  }}
                >
                  <ImgOptimized
                    src={img}
                    alt={`masonry-right-${idx}`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      borderRadius: "16px",
                      objectFit: "cover",
                      background: "#eee",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              ))}
              {rightImages.map((img, idx) => (
                <div
                  key={`right-dup-${idx}`}
                  className="image-container mb-4"
                  style={{
                    height: `${Math.floor(Math.random() * 100) + 160}px`,
                    marginBottom: "16px",
                  }}
                >
                  <ImgOptimized
                    src={img}
                    alt={`masonry-right-dup-${idx}`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      borderRadius: "16px",
                      objectFit: "cover",
                      background: "#eee",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* </div> */}
      </Box>
    );
  }, []);

  let token = localStorage.getItem("usersdatatoken");
  const axiosConfig = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  const setVal = (e, isLowercase) => {
    const { name, value } = e.target;
    setInpval((prevValues) => ({
      ...prevValues,
      [name]: isLowercase ? value.toLowerCase() : value,
    }));
  };

  const loginuser = async (e) => {
    e.preventDefault();
    let toastId;

    const { email, password } = inpval;

    if (email === "") {
      toast.error("Email is required!");
    } else if (!email.includes("@")) {
      toast.warning("Include @ in your email!");
    } else if (password === "") {
      toast.error("Password is required!");
    } else {
      toastId = toast.loading("Logging in...");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/user/login`,
          {
            email: email.toLowerCase(),
            password,
            ...(loginId.isValid ? { loginId: LOGIN_ID } : { otp: inpval.otp }),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const res = response.data;

        if (res.status === 200) {
          toast.update(toastId, {
            render: "Login Successful...",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
          dispatch(setUser(res.result));
          localStorage.setItem("usersdatatoken", res.result.token);
          localStorage.setItem("loginId", res.result.loginId);
          setLoginId({
            loginId: res.result.loginId,
            isValid:
              res.result?.loginId &&
              res.result?.loginId !== "undefined" &&
              res.result?.loginId !== "null",
          });
          localStorage.setItem("user", res.result.email);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          navigate("/home", { replace: true });
          setInpval({ ...inpval, email: "", password: "" });
        } else {
          toast.update(toastId, {
            render: res?.message || "Login failed",
            type: "error",
            isLoading: false,
            autoClose: 2000,
          });
        }
      } catch (error) {
        if (error?.response?.data?.error == "Invalid loginId") {
          setLoginId({
            loginId: null,
            isValid: false,
          });
          localStorage.removeItem("loginId");
        }
        console.log("Login error:", error);
        toast.update(toastId, {
          render: error?.response?.data?.error,
          type: "error",
          isLoading: false,
          autoClose: 2000,
        });
      }
    }
  };

  const sendOtp = async () => {
    if (!inpval.email) {
      toast.error("Please enter your email to send OTP.");
      return;
    }
    if (!inpval.password) {
      toast.error("Please enter your password to send OTP.");
      return;
    }
    setOtpBtnLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/user/login-otp`,
        { email: inpval.email.toLowerCase(), password: inpval.password },
      );

      if (res.status === 200) {
        toast.success(res?.data?.message || "OTP sent successfully!");
      }
      setIsOtpSend(true);
    } catch (error) {
      console.log({ error: error?.response?.data?.error });
      toast.error(error?.response?.data?.error ?? "Failed to send OTP.");
    } finally {
      setOtpBtnLoading(false);
    }
  };

  return (
    <>
      <section className="flex md:flex-row flex-col  items-center justify-center h-screen  bg-white font-[satoshi]  ">
        {LEFTCARAOUSEL}
        <Flex
          // flexBasis={"50%"}
          className="h-full md:flex-1 justify-center items-center relative"
        >
          <Box
            maxW={"500px"}
            w={"90%"}
            // h={"200px"}
            // border={"1px solid #ccc"}
          >
            <Heading
              color={"black"}
              textAlign={"center"}
              size={"xl"}
              lineHeight={"125%"}
              mb={8}
              fontFamily={"satoshi !important"}
            >
              Welcome to AirBrick <br />
              Workspace Template Library
            </Heading>
            <form className="space-y-4" action="#">
              <Input
                bgColor={"gray.50"}
                rounded={"8px"}
                size={"lg"}
                // colorScheme="red"
                type="email"
                placeholder="Enter your Email ID"
                value={inpval.email}
                onChange={(e) => setVal(e, true)}
                name="email"
                id="email"
                required
              />

              <InputGroup
                bgColor={"gray.50"}
                rounded={"8px"}
                size={"lg"}
                mb={"6 !important"}
              >
                <Input
                  // colorScheme="red"
                  type={!passShow ? "password" : "text"}
                  onChange={setVal}
                  value={inpval.password}
                  name="password"
                  id="password"
                  placeholder="Enter Password"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-green-600 focus:border-primary-500 block w-full px-2.5 md:py-3.5"
                  required
                />
                <InputRightElement>
                  <span
                    // className="absolute inset-y-0 top-2 md:top-3 right-3"
                    onClick={() => setPassShow(!passShow)}
                  >
                    {!passShow ? (
                      <Unicons.UilEye color="gray" />
                    ) : (
                      <Unicons.UilEyeSlash color="gray" />
                    )}
                  </span>
                </InputRightElement>
              </InputGroup>
              {!loginId.isValid && (
                <InputGroup
                  bgColor={"gray.50"}
                  rounded={"8px"}
                  size={"lg"}
                  mb={"6 !important"}
                >
                  <Input
                    // colorScheme="red"
                    type={"text"}
                    onChange={setVal}
                    value={inpval.otp}
                    name="otp"
                    id="otp"
                    placeholder="Enter OTP"
                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-green-600 focus:border-primary-500 block w-full px-2.5 md:py-3.5"
                    required
                  />
                  <InputRightElement w={"fit-content"}>
                    <Button
                      isLoading={otpBtnLoading}
                      loadingText={"Sending ..."}
                      colorScheme="teal"
                      variant={"outline"}
                      onClick={sendOtp}
                    >
                      Send OTP
                    </Button>
                  </InputRightElement>
                </InputGroup>
              )}

              <button
                type="submit"
                disabled={!loginId.isValid ? !isOtpSend || !inpval.otp : false}
                onClick={loginuser}
                className={classNames(
                  "w-full text-white font-bold  transition-colors focus:ring-1 focus:outline-none rounded-full text-sm px-2.5 py-3.5 text-center  ",
                  (!loginId.isValid ? !isOtpSend || !inpval.otp : false)
                    ? "bg-gray-400 hover:bg-gray-500 cursor-not-allowed"
                    : "bg-teal-500 hover:bg-teal-600",
                )}
              >
                Sign in
              </button>
              {/* <div className="flex items-center gap-2">
                <div className="h-[1px] bg-gray-200 w-full grow"></div>
                <p className="text-center text-black">OR</p>
                <div className="h-[1px] bg-gray-200 w-full grow"></div>
              </div>
              <button
                type="button"
                onClick={() => navigate("/project-list")}
                className="w-full font-bold text-black border border-black hover:bg-gray-100 transition-colors  rounded-full text-sm px-2.5 py-3.5 text-center"
              >
                View Projects
              </button> */}
            </form>
          </Box>
          {/*  <ImgOptimized src={bottomImg} className="absolute bottom-0 right-0" /> */}
        </Flex>
      </section>
    </>
  );
};

export default Login;
